import { render, staticRenderFns } from "./filesIcon.vue?vue&type=template&id=b19ae45a&"
import script from "./filesIcon.vue?vue&type=script&lang=js&"
export * from "./filesIcon.vue?vue&type=script&lang=js&"
import style0 from "./filesIcon.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
